import React, { memo, useState, useContext } from "react";
import { useDrag } from "react-dnd";
import {textWidth, fitText} from "../../functions/TextUtils";
import MxTooltip from "./MxTooltip";
import moment from "moment";
import __ from "lodash";
import SystemContext from "../../SystemContext";

const Maintenance = (props) => {
  const {data: mx, blockSize, timelineStartsAt, row, editing, colours} = props;
  const [toolTipOpen, setToolTipOpen] = useState({open:false, x:0, y:0});
  const {brokenStart, brokenEnd} = mx

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const toolTipCloseHandler = (e) => {
    console.log('tooltip closed');
    setToolTipOpen({...toolTipOpen, open:false});
  }

  const toolTipOpenHandler = () => {
    setToolTipOpen({...toolTipOpen, open:true});
  }

  const handleClick = (e) => {
    const x = e.clientX;
    const y = e.currentTarget.getBoundingClientRect().y;
    setToolTipOpen({...toolTipOpen, open:true, x, y});
    //console.log("clicked");
  }

  let bgColor = props.changed?"rgba(0,255,255,0.75)":(brokenStart||brokenEnd)?"rgba(127,51,88,1)":"#815B2C";
  const colourRow = __.findIndex(colours, {code: `MX STATUS`});
  if (colours && colourRow > -1) {
    if (props.changed) {
      const changedColorExists = __.has(colours[colourRow].value, 'CHANGED');   
      if (changedColorExists) {
        bgColor = colours[colourRow].value['CHANGED'];
      }
    } else if (brokenStart || brokenEnd) {
      const statusColorExists = __.has(colours[colourRow].value, "AIRPORT CONFLICT");   
      if (statusColorExists) {
        bgColor = colours[colourRow].value["AIRPORT CONFLICT"];
      } else {
        bgColor = "rgba(127,51,88,1)";
      }
    } else {
      const statusColorExists = __.has(colours[colourRow].value, mx.aircraftCheck);   
      if (statusColorExists) {
        bgColor = colours[colourRow].value[mx.aircraftCheck];
      } else {
        const defaultColorExists = __.has(colours[colourRow].value, 'DEFAULT');    
        if (defaultColorExists) bgColor = colours[colourRow].value['DEFAULT'];    
      }
    }
  }

  const startTime = mx.startCheckDate;
  const endTime = mx.endCheckDate;
  const status = mx.status;

  const startDate = moment(startTime).startOf('day');
  const startHour = moment(startTime);
  const endHour = moment(endTime);
  const duration = moment(endHour).diff(moment(startHour),'minute');

  const startPos = (blockSize/60) * (moment(startHour).diff(moment(timelineStartsAt),'minute')) + (blockSize<12?0:25);
  const size = (blockSize/60) * duration; 

  const text = `${mx.mxAircraftCheckInfo || mx.aircraftCheck} (${mx.mxAirportCode})`;
  const infoSize = textWidth({text ,options: { font: 'verdana', size: 13}});
  const {fontSize: infoFontSize, textSize:infoTextSize} = fitText({text, maxSize:size, maxFontSize:13, minFontSize:10, options:{ font: 'verdana', bold: true }});
  const {fontSize: codeFontSize, textSize:codeTextSize} = fitText({text:`${mx.aircraftCheck} (${mx.mxAirportCode})`,maxSize:size, maxFontSize:13, minFontSize:10, options:{ font: 'verdana', bold: true }});
  const {fontSize: codeOnlyFontSize, textSize:codeOnlyTextSize} = fitText({text:`${mx.aircraftCheck}`,maxSize:size, maxFontSize:13, minFontSize:6, options:{ font: 'verdana', bold: true }});

  let repeatSize = infoSize + 20;
  let repeats = Math.floor(size / repeatSize);
  let repeatText = text;
  let repeatFont = 13;
  if (repeats < 1) {
    if (infoTextSize > 0) {
      repeatText = text;
      repeatFont = infoFontSize;
    } else if (codeTextSize > 0) {
      repeatText = `${mx.aircraftCheck} (${mx.mxAirportCode})`;
      repeatFont = codeFontSize;      
    } else if (codeOnlyTextSize > 0){
      repeatText = `${mx.aircraftCheck}`;
      repeatFont = codeOnlyFontSize;
    } else {
      repeatText = ``;
    }
    repeatSize = size;
    repeats = 1;
  }
  //console.log(startTime, size, repeats, repeatText, repeatSize);

  const [{dragging}, dragRef] = useDrag(() => ({
    type: "MAINTENANCE", 
    item: {type: "MAINTENANCE", trip: mx, size, blockSize, startHour, duration, endHour},
    collect: (monitor) => ({
      dragging: monitor.isDragging()
    })
  }), [mx]);

  const handleContextMenu = (event) => {
    event.preventDefault();
    eventBus.trigger(`RouteView.TimeWindow.MxContextMenu`, {
      maintenance: mx,
      x: event.clientX,
      y: event.clientY,
    });
  };

  let startPosInner = 0;
  let boxPath = `M0,0L${(size)},0L${(size)},23L0,23L0,0Z`;
  let strokeWidth = 0.5;
  let stroke = "rgb(0,0,0)";
  if (!props.changed) {
    if (brokenStart && brokenEnd) {
      strokeWidth = 1;
      stroke = "rgb(120,0,0)";
      boxPath = `M3,0L${(size)},0L${(size - 3)},4L${(size)},8L${(size - 3)},12L${(size)},16,L${(size - 3)},20,L${(size)},23,L3,23L0,20L3,16L0,12L3,8L0,4L3,0Z`;
    } else if (brokenStart) {
      strokeWidth = 1;
      stroke = "rgb(120,0,0)";
      boxPath = `M3,0L${(size)},0L${(size)},23L3,23L0,20L3,16L0,12L3,8L0,4L3,0Z`;
    } else if (brokenEnd) {
      strokeWidth = 1;
      stroke = "rgb(120,0,0)";
      boxPath = `M0,0L${(size)},0L${(size - 3)},4L${(size)},8L${(size - 3)},12L${(size)},16,L${(size - 3)},20,L${(size)},23,L0,23L0,0Z`;
    }  
  }

  const mxControl = editing && status !== 'CONFIRMED' ?(
    <div ref={dragRef} onClick={handleClick} onContextMenu={handleContextMenu} style={{contentVisibility: "auto", position:"absolute", left: (startPos - blockSize), top: 3, height: 24, minHeight: 24, maxHeight: 24, display: "block", width: size, minWidth: size, maxWidth: size, backgroundColor: "rgba(0, 0, 0, 0)", textAlign:"left", marginTop: (row * 30)}}>
      <svg width={size} height={24} viewBox={`0 0 ${size} 24`} version="1.1" style={{fillRule:"evenodd", clipRule:"evenodd", strokeLinejoin:"round", strokeMiterlimit: 2}}>
        <g transform={`translate(${startPosInner}, 0.5)`}>
          <path d={boxPath} style={{fill: bgColor, strokeWidth, stroke}}/>
        </g>
        {/* <rect width={size} height={24}  style={{fill: bgColor, strokeWidth:0.5, stroke: "rgb(0,0,0)"}} /> */}
        {repeatSize > 0?[...Array(repeats)].map((r, i) => (
          <text key={i} x={((size % repeatSize) / 2) + (repeatSize/2) + (i * repeatSize)} y="50%" dominantBaseline="middle" textAnchor="middle" style={{fill: "#ffffff", stroke: "#ffffff", font: `${repeatFont}px verdana`}}>{repeatText}</text>
        )):null}
      </svg>
    </div>
  ): (
    <div onClick={handleClick} onContextMenu={handleContextMenu} style={{contentVisibility: "auto", position:"absolute", left: (startPos - blockSize), top: 3, height: 24, minHeight: 24, maxHeight: 24, display: "block", width: size, minWidth: size, maxWidth: size, backgroundColor: "rgba(0, 0, 0, 0)", textAlign:"left", marginTop: (row * 30)}}>
      <svg width={size} height={24} viewBox={`0 0 ${size} 24`} version="1.1" style={{fillRule:"evenodd", clipRule:"evenodd", strokeLinejoin:"round", strokeMiterlimit: 2}}>
        <g transform={`translate(${startPosInner}, 0.5)`}>
          <path d={boxPath} style={{fill: bgColor, strokeWidth, stroke}}/>
        </g>
        {/* <rect width={size} height={24}  style={{fill: bgColor, strokeWidth:0.5, stroke: "rgb(0,0,0)"}} /> */}
        {repeatSize > 0?[...Array(repeats)].map((r, i) => (
          <text key={i} x={((size % repeatSize) / 2) + (repeatSize/2) + (i * repeatSize)} y="50%" dominantBaseline="middle" textAnchor="middle" style={{fill: "#ffffff", stroke: "#ffffff", font: `${repeatFont}px verdana`}}>{repeatText}</text>
        )):null}
      </svg>
    </div>
  )

  if (toolTipOpen.open) {
    return (
      <MxTooltip data={mx} editing={editing} onClose={toolTipCloseHandler} position={{x: toolTipOpen.x, y: toolTipOpen.y}}>
        {mxControl}
      </MxTooltip>
    )
  }

  return (
    <>{mxControl}</>
  )

}

export default memo(Maintenance);